import { ApplicationConfig, inject } from '@angular/core';
import { DefaultOptions, InMemoryCache } from '@apollo/client/core';
import { envs } from '@envs/environment';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

export const graphqlProvider: ApplicationConfig['providers'] = [
  provideApollo(() => {
    const httpLink = inject(HttpLink);

    const cache = new InMemoryCache({
      addTypename: false,
    });

    const link = httpLink.create({
      uri: envs.graphqlUrl,
    });

    const defaultOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: 'no-cache',
      },
      query: {
        fetchPolicy: 'no-cache',
      },
      mutate: {
        fetchPolicy: 'no-cache',
      },
    };

    return {
      link,
      cache,
      defaultOptions,
    };
  }),
];
